/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { qs } from 'url-parse';
import type ProjectComponentsType from '@jira/spa-apps__project-components/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Match, Query } from '@atlassian/react-resource-router';
import { RedirectToProjectType } from './project-type/index.tsx';

export const LazyProjectComponentsSettings: LazyComponent<
	React.MemoExoticComponent<() => React.JSX.Element>
> = lazyForPaint<typeof ProjectComponentsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-components", jiraSpaEntry: "async-project-components" */ '@jira/spa-apps__project-components/src/ExportedDefault.tsx'
		),
	),
);

export const SettingsComponentsRedirect = (): React.JSX.Element => {
	const page = (_: Match, { selectedItem, ...rest }: Query) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
		const querystring = qs.stringify(rest, true);
		return `/settings/components${querystring}`;
	};
	return <RedirectToProjectType page={page} />;
};

const AsyncProjectComponentsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectComponentsSettings}
		pageId="project-settings-components"
		shouldShowSpinner
	/>
);

export default AsyncProjectComponentsSettings;
